module.exports = {
      id: "liveupdate-usage",
      viewBox: "0 0 14.54 20",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#liveupdate",
      toString: function () {
        return this.url;
      }
    }